import Vue from 'vue';
import * as types from './types';

function getTrackerIndexByUuid(state, id) {
  return state.parsedFileResult
    .map((object) => object.uuid).indexOf(id);
}

const mutations = {
  [types.SET_SELF_SERVICE_TRACKERS]: (state, payload) => {
    state.contentTrackers = payload;
  },
  [types.ADD_SELF_SERVICE_TRACKERS]: (state, payload) => {
    const selectedItemIndex = state.contentTrackers
      .findIndex((item) => item.contentItemUuid === payload.contentItemUuid);
    if (selectedItemIndex === -1) {
      state.contentTrackers.push(payload);
    } else {
      Vue.set(
        state.contentTrackers,
        selectedItemIndex,
        payload,
      );
    }
  },
  [types.SET_TRACKERS_FOR_VALIDATION]: (state, payload) => {
    state.selectedTrackersForValidation = payload;
  },
  [types.SET_COMBINATION_SPLIT]: (state, payload) => {
    state.combinationSplit = payload;
  },
  [types.SET_COLUMNS_TO_DISPLAY]: (state, payload) => {
    state.columnsToDisplay = payload;
  },
  [types.UPDATE_TRACKERS_SELECTED_COMBINATIONS]: (state, payload) => {
    state.trackersSelectedCombinations = payload;
  },
  [types.UPDATE_TRACKERS_FOR_VALIDATION_BY_ITEM]: (state, payload) => {
    const index = state.selectedTrackersForValidation.findIndex((item) => item.uuid === payload.uuid);
    Vue.set(
      state.selectedTrackersForValidation,
      index,
      payload,
    );
  },
  [types.SET_PARSED_FILE_RESULT]: (state, payload) => {
    const { headers, rows, fileUploadUuid } = payload;
    state.parsedFileHeaders = headers;
    state.parsedFileResult = rows;
    state.fileUploadUuid = fileUploadUuid;
  },
  [types.SET_IMPORTING_PLACEMENT_LEVEL_TRACKERS]: (state, payload) => {
    state.isImportingPlacementLevelTrackers = payload;
  },
  [types.SET_TRACKERS_HEALTH_STATUS_DATA]: (state, payload) => {
    state.trackersHealthStatusData = payload;
  },
  [types.REMOVE_TRACKER]: (state, payload) => {
    const selectedItemIndex = getTrackerIndexByUuid(state, payload.uuid);
    if (selectedItemIndex !== -1) {
      state.parsedFileResult
        .splice(selectedItemIndex, 1);
    }
  },
  [types.UPDATE_TRACKER_COMBINATION]: (state, payload) => {
    const selectedItemIndex = getTrackerIndexByUuid(state, payload.uuid);
    Vue.set(
      state.parsedFileResult,
      selectedItemIndex,
      payload,
    );
  },
  [types.SET_GROUPED_TRACKERS_LIST]: (state, payload) => {
    state.groupedTrackersList = payload;
  },
  [types.REMOVE_GROUP_FROM_GROUPED_LIST]: (state, groupName) => {
    delete state.groupedTrackersList[groupName];
  },
  [types.APPEND_ITEM_TO_GROUPED_LIST]: (state, payload) => {
    const { groupName, tracker } = payload;
    state.groupedTrackersList[groupName].push(tracker);
  },
  [types.CHANGE_ITEM_IN_GROUPED_LIST]: (state, payload) => {
    const {
      groupName, index, trackerType, tracker,
    } = payload;

    state.groupedTrackersList[groupName][index][trackerType] = tracker[trackerType];

    Vue.set(
      state.groupedTrackersList[groupName][index],
      trackerType,
      tracker[trackerType],
    );
  },
  [types.REMOVE_ITEM_FROM_GROUPED_LIST]: (state, payload) => {
    const { groupName, index } = payload;
    // Remove a specific item from the array of trackers in groupedTrackersList...
    state.groupedTrackersList[groupName].splice(index, 1);
  },
};

export default mutations;
